export const PAGE_CONFIG = {
  "name": "CommonHeader",
  "data": {
    "subtitle": "-"
  },
  "config": {
    "title": "GTDR Assessment",
    "titleCn": "GTDR评估",
    "subtitle": "Last Updated : {{subtitle}}",
    "subtitleCn": "最近更新 : {{subtitle}}",
    "customSubTitle": true
  },
  "children": [
    {
      "name": "CommonContantWrap",
      "config": {
        "isHaveNotification": true,
        "notificationPath": "/benchmark/gtdrAssessment",
        "logConfig": {
          "typeId": "dashboard_pc_v2",
          "uidType": "game_code",
          "pageId": "206101",
          "pageName": "GTDRAssessment",
          "extInfo": "GTDRAssessment",
          "pagePath": "/benchmark/gtdrAssessment"
        }
      },
      "children": [
        {
          "name": "GTDRAssessmentFilter",
          "props": {
            "renderChildren": true,
            "checkBoxConfig": {
              "value": [
                "height",
                "mid",
                "low"
              ],
              "checkList": [
                {
                  "value": "height",
                  "key": "benchmark_high",
                  "name": "Benchmark-High",
                  "nameEn": "Benchmark-High",
                  "nameCn": "行业基准-好"
                },
                {
                  "value": "mid",
                  "key": "benchmark_mid",
                  "name": "Benchmark-Mid",
                  "nameEn": "Benchmark-Mid",
                  "nameCn": "行业基准-中"
                },
                {
                  "value": "low",
                  "key": "benchmark_low",
                  "name": "Benchmark-Low",
                  "nameEn": "Benchmark-Low",
                  "nameCn": "行业基准-差"
                }
              ]
            }
          },
          "children": [
            {
              "name": "GTDRCommonService",
              "props": {
                "api": "/api/v1/dashboard/pc/gtdr/project/performance"
              },
              "children": [
                {
                  "name": "GTDROverview",
                  "data": {
                    "gameVersion": "-",
                  },
                  "props": {
                  },
                  "children": [
                    {
                      "name": "GTDRRadarChart",
                      "props": {
                        "style": {
                          "marginTop": "20px"
                        },
                        "titleEn": "GTDR Performance Overview",
                        "titleCn": "GTDR表现概览",
                        "subtitle": "{{gameVersion}}",
                        "cardHeight": 680,
                        "showDownloadBtn": true,
                        "showFullscreenBtn": true
                      },
                      
                    },
                    {
                      "name": "GTDRSummaryService",
                      "props": {
                        "api": "/api/v1/dashboard/pc/gtdr/summary",
                        "dataKey": "summary"
                      },
                      "children": [
                        {
                          "name": "GTDRSummaryCard",
                          "className": "margin-t-20",
                          "props": {
                            "titleEn": "Summary",
                            "titleCn": "总结"
                          }
                        }
                      ]
                    },
                    {
                      "name": "GTDRRiskLevelService",
                      "props": {
                        "api": "/api/v1/dashboard/pc/gtdr/class/risk_level"
                      },
                      "children": [
                        {
                          "name": "GTDRRiskLevel",
                          "className": "",
                          "props": {
                          }
                        }
                      ]
                    },
                  ]
                },
                {
                  "name": "GTDRTableCard",
                  "props": {
                    "style": {
                      "marginTop": "20px"
                    },
                    "titleEn": "Comparison Overview",
                    "titleCn": "详细对比",
                    "colorLists": {
                      "light": [
                        "#C63F53",
                        "#E67B8F",
                        "#29C182"
                      ],
                      "dark": [
                        "#9F3044",
                        "#BC5D6B",
                        "#64B691"
                      ]
                    }
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
